import { env } from "@/env.mjs";

export const formatDate = (dateString: string) => {
	const options = {
		day: "numeric",
		month: "long",
		year: "numeric",
	} as const;
	const date = new Date(dateString);
	return date.toLocaleDateString("en", options);
};

export const getPublicUrl = () => {
	if (typeof window === "undefined") {
		return env.NEXT_PUBLIC_BASE_URL;
	}
	return window.location.origin;
};

/**
 *
 * @param mobile {number} - default 100
 * @param desktop {number} - default 50
 * @returns {string} - (max-width: 768px) 100vw, 50vw
 */
export const sizes = (mobile = 100, desktop = 50) => {
	return `(max-width: 768px) ${mobile}vw, ${desktop}vw`;
};

export const getCentraMedia = (
	media: Record<string, string[]> | undefined,
	key: string,
) => {
	if (!media) return undefined;

	return {
		href: media[key]?.[0],
		alt: "",
	};
};

export const getBaseUrl = () => {
	if (typeof window !== "undefined") {
		return window.location.origin;
	} else if (process.env.NODE_ENV === "development") {
		return "https://localhost:3000";
	} else if (process.env.VERCEL_ENV === "production") {
		return "https://scandinavianexplorer.no";
	} else {
		return "https://scandinavianexplorer.no";
	}
};

export const removeSegmentFromUrl = (url: string, segments: string[]) => {
	return url
		.split("/")
		.filter((segment) => !segments.includes(segment))
		.join("/");
};
